import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AuthStore } from '@app/stores/auth.store';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: '[app-navbar-horizontal]',
  standalone: true,
  imports: [CommonModule, TranslatePipe, RouterLink],
  templateUrl: './navbar-horizontal.component.html',
  styleUrl: './navbar-horizontal.component.scss',
})
export class NavbarHprizontalComponent implements OnInit {
  private readonly router = inject(Router);
  protected readonly authStore = inject(AuthStore);
  protected readonly isAdmin = this.authStore.isAdmin;

  constructor() {}

  ngOnInit(): void {
    var navbarStyle = localStorage.getItem('navbarStyle');
    if (navbarStyle && navbarStyle !== 'transparent') {
      document
        .querySelector('.navbar-horizontal')
        ?.classList?.add(`navbar-${navbarStyle}`);
    }
  }

  goToAdmin(): void {
    this.router.navigate(['/admin/approvals']);
  }
}
